import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["operationPrice", "comission", "communityFee", "payToOwner"]

  connect() {
    this.manualOverride = false
  }

  calculate() {
    this.manualOverride = false
    this._updatePayToOwner()
  }

  markManual() {
    this.manualOverride = true
  }

  _updatePayToOwner() {
    if (this.manualOverride) return

    const operationPrice = parseFloat(this.operationPriceTarget.value) || 0
    const comission = parseFloat(this.comissionTarget.value) || 0
    const communityFee = parseFloat(this.communityFeeTarget.value) || 0

    const result = operationPrice - comission - communityFee
    this.payToOwnerTarget.value = result.toFixed(2)
  }
}
